import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "html5table"
    }}>{`HTML5Table`}</h1>
    <p>{`The `}<inlineCode parentName="p">{`HTML5Table`}</inlineCode>{` component has the exact same props as the
`}<inlineCode parentName="p">{`WindowTable`}</inlineCode>{` component.`}</p>
    <p>{`The main difference is that, here, we have overriden the wrapping components.`}</p>
    <p>{`Let's look at some code to understand what that means...`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "harmony",
        "harmony": true
      }}>{`const Html5TableExample = props => {
  return (
    <WindowTable
      className="table"
      Cell="td"
      HeaderCell="th"
      Header='thead'
      HeaderRow="tr"
      Row="tr"
      Body="tbody"
      Table="table"
      {...props}
    />
  );
};
`}</code></pre>
    <p>{`In addition to that, the `}<inlineCode parentName="p">{`Html5Table`}</inlineCode>{` component accepts an additional prop: `}<inlineCode parentName="p">{`headerClassName`}</inlineCode>{`.
This is convenient for cases where the `}<inlineCode parentName="p">{`thead`}</inlineCode>{` components need special class names.`}</p>
    <p>{`eg:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "harmony",
        "harmony": true
      }}>{`<Html5Table
    data={data}
    columns={columns}
    className="table-sm table-striped"
    headerClassName="thead-dark"
/>
`}</code></pre>
    <p>{`of course, this could have been done by overriding the `}<inlineCode parentName="p">{`Header`}</inlineCode>{` by yourself.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "harmony",
        "harmony": true
      }}>{`<Html5Table
    data={data}
    columns={columns}
    className="table-sm table-striped"
    Header={function THead(props) {
      return <thead {...props} className="thead-dark" />
    }}
/>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      